var ua = window.navigator.userAgent || '';
/**
 * 版本号比较
 * @param versionA
 * @param versionB
 * @returns
 */
export var semverCompare = function semverCompare(versionA, versionB) {
  var splitA = versionA.split('.');
  var splitB = versionB.split('.');
  for (var i = 0; i < 3; i++) {
    var snippetA = Number(splitA[i]);
    var snippetB = Number(splitB[i]);
    if (snippetA > snippetB) return 1;
    if (snippetB > snippetA) return -1;
    // e.g. '1.0.0-rc' -- Number('0-rc') = NaN
    if (!isNaN(snippetA) && isNaN(snippetB)) return 1;
    if (isNaN(snippetA) && !isNaN(snippetB)) return -1;
  }
  return 0;
};
/**
 * 获取 ios 大版本号
 */
export var getIOSVersion = function getIOSVersion() {
  var version = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
  return Number.parseInt(version[1], 10);
};
// 是否是安卓
export var isAndroid = /android/i.test(ua);
// 是否IOS
export var isIOS = /iphone|ipad|ipod/i.test(ua);
// 安卓 chrome 浏览器，包含 原生chrome浏览器、三星自带浏览器、360浏览器以及早期国内厂商自带浏览器
export var isOriginalChrome = /chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(ua) && isAndroid && ua.indexOf('Version') < 0;
// QQ浏览器
export var isQQBrowser = /qqbrowser/i.test(ua);
// 火狐浏览器
export var isFirefox = /firefox/i.test(ua);
// 百度浏览器
export var isBaidu = /baidubrowser/i.test(ua);
/**
 * 判断是否执行 scheme 到 link或失败回调
 * @returns boolean
 */
export var haveSchemeToLinkOrFallback = function haveSchemeToLinkOrFallback() {
  return isAndroid || getIOSVersion() < 9;
};